export {
  AUTOFILL_FIELD_STATUSES,
  CONFIDENT_JOB_THRESHOLD,
  EXTENSION_APPLY_OUTCOMES,
  FIELD_VALUE_SOURCES,
  FIT_VERDICTS,
  FORM_FIELD_KINDS,
  JOB_EXTRACTION_METHODS,
  JOB_WORK_MODES,
} from './extension.ts';
